import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Option, SkeletonLoaderDirective } from '@com-delta-omnichannel/aura';
import {
  Banner,
  EnrollDetail,
  FooterComponent,
  HeaderComponent,
  NotificationComponent,
  OptionsComponent,
  ReviewComponent,
  StatusComponent
} from '../../features';
import { MilesRolloverPage } from './models/miles-rollover-page.interfaces';

@Component({
  selector: 'idp-miles-rollover-page',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    StatusComponent,
    OptionsComponent,
    FooterComponent,
    ReviewComponent,
    NotificationComponent,
    SkeletonLoaderDirective
  ],
  templateUrl: './miles-rollover-page.component.html',
  styleUrls: ['./miles-rollover-page.component.scss']
})
export class MilesRolloverPageComponent {
  @Input() content: MilesRolloverPage = {} as MilesRolloverPage;
  @Output() openLink = new EventEmitter<string>();
  @Output() closeError: EventEmitter<void> = new EventEmitter<void>();
  @Output() enroll: EventEmitter<EnrollDetail[]> = new EventEmitter<
    EnrollDetail[]
  >();

  @Output() selectedExtension: EventEmitter<Option> =
    new EventEmitter<Option>();

  getImageSource(banner: Banner): string {
    return window.innerWidth <= 768 ? banner.mobile.src : banner.desktop.src;
  }
}
